export const getTruncatedPhoneNumber = ({ phone, countryCode, phoneUtil }) => {
  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phone, countryCode);
    const nationalNumber = parsedNumber.getNationalNumber();
    return JSON.stringify(nationalNumber);
  } catch (err) {
    return phone;
  }
};

export const validatePhoneNumber = ({ phone, countryCode, phoneUtil }) => {
  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phone, countryCode);
    const isValidNumber = phoneUtil.isValidNumber(parsedNumber);

    return isValidNumber;
  } catch (err) {
    return !!phone && phone.length > 0;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validate-phone.js